import {getVendingOccupancyContent, Product} from "./types";
import {Occupancy} from "@variocube/app-api";
import {getRandomElement} from "@variocube/app-common";

export interface InventoryPosition {
    product: Product;
    occupancies: Occupancy[];
}

export class Inventory {

    private readonly positions = new Map<string, InventoryPosition>();

    constructor(products: Product[], occupancies: Occupancy[]) {
        this.positions = new Map(products.map(product => [product.id, {product, occupancies: []}]));

        for (const occupancy of occupancies) {
            const content = getVendingOccupancyContent(occupancy);
            if (content) {
                const position = this.positions.get(content.product);
                if (position) {
                    position.occupancies.push(occupancy);
                }
            }
        }
    }

    private getPosition(product: Product) {
        return this.positions.get(product.id);
    }

    getCount(product: Product) {
        return this.getPosition(product)?.occupancies.length ?? 0;
    }

    getAnyOccupancy(product: Product) {
        return getRandomElement(this.getPosition(product)?.occupancies ?? []);
    }
}